/**
 * 購入制限警告モーダル (共通) + カート画面 <quantity-input> 制御
 *
 * - window.showPurchaseLimitWarning(text) でテキスト差し替え + 表示
 * - text 空なら閉じる
 * - カート画面の <quantity-input> + ボタン押下時に上限超過なら preventDefault + モーダル表示
 *
 * 商品ページの「+」/「カートに追加」制御は my-cart-button.js 側で window.showPurchaseLimitWarning を呼ぶ。
 */
(function () {
  // 多重ロード防止 (snippet が複数回 render されるケース)
  if (window.__orimine_purchase_limit_modal_init) return;
  window.__orimine_purchase_limit_modal_init = true;

  function getModal() {
    return document.getElementById('purchase-limit-modal');
  }

  // モーダル制御 (window 公開)
  window.showPurchaseLimitWarning = function (text) {
    const modal = getModal();
    if (!modal) return;
    if (!text) {
      modal.classList.add('tw-hidden');
      return;
    }
    const msgEl = document.getElementById('purchase-limit-modal-message');
    if (msgEl) msgEl.textContent = text;
    modal.classList.remove('tw-hidden');
  };

  function attachModalCloseHandlers() {
    const modal = getModal();
    if (!modal) return;
    // 閉じるボタン
    modal.querySelectorAll('.purchase-limit-modal-close').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.classList.add('tw-hidden');
      });
    });
    // 背景クリック
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.classList.add('tw-hidden');
    });
  }

  // カート画面 <quantity-input> 制御 (Dawn 標準ハンドラより先にキャプチャ)
  function attachCartQuantityHandlers() {
    document.querySelectorAll('quantity-input').forEach(function (wrapper) {
      const input = wrapper.querySelector('input.quantity__input');
      if (!input) return;
      const attr = input.dataset.purchaseLimit;
      if (attr === undefined || attr === '' || attr === null) return;
      const limit = parseInt(attr, 10);
      if (!Number.isFinite(limit)) return;

      // limit < 0 はデータ不正、無視 (制限なし扱い)
      if (limit < 0) return;

      // 0 = 購入制限中 (blocked) → + ボタン + 直接入力 完全ブロック
      const isBlocked = limit === 0;
      const blockedMsg = '現在購入制限中のため、こちらの商品はご購入いただけません。';
      const limitMsg = 'この商品はお一人様 ' + limit + ' 単位までのご購入とさせていただいております。';

      // + ボタン押下
      const plusBtn = wrapper.querySelector('button[name="plus"]');
      if (plusBtn) {
        plusBtn.addEventListener(
          'click',
          function (e) {
            const currentVal = parseInt(input.value, 10) || 0;
            if (isBlocked || currentVal >= limit) {
              e.preventDefault();
              e.stopImmediatePropagation();
              window.showPurchaseLimitWarning(isBlocked ? blockedMsg : limitMsg);
              return false;
            }
          },
          { capture: true }
        );
      }

      // 直接入力 / change イベント
      input.addEventListener('change', function () {
        const val = parseInt(input.value, 10) || 0;
        if (isBlocked) {
          // 購入制限中 → カート内既存数量に戻す (= 増加は許可しない)。
          // 既に入っている個数を維持しつつ、新たに増やす操作を阻止。
          const cartQty = parseInt(input.dataset.cartQuantity, 10);
          input.value = Number.isFinite(cartQty) && cartQty > 0 ? cartQty : 1;
          window.showPurchaseLimitWarning(blockedMsg);
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        if (val > limit) {
          input.value = limit;
          window.showPurchaseLimitWarning(limitMsg);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    attachModalCloseHandlers();
    attachCartQuantityHandlers();
  });
})();
